import type { Sqlite3MtDebugStagePayload } from './sqlite3mt/types'

export const SECUREBLOB_RUNTIME_TRACE_EVENT = 'secureblob:runtime-trace'

export interface BrowserRuntimeTraceSqliteDebugStageEvent {
    readonly kind: 'sqlite:debug-stage'
    readonly blobId: string
    readonly path: string
    readonly workspaceName: string
    readonly payload: Sqlite3MtDebugStagePayload
}

export type BrowserRuntimeTraceEvent = BrowserRuntimeTraceSqliteDebugStageEvent

export function dispatchBrowserRuntimeTraceEvent(detail: BrowserRuntimeTraceEvent): void {
    if (typeof globalThis.dispatchEvent !== 'function' || typeof CustomEvent === 'undefined') {
        return
    }

    globalThis.dispatchEvent(new CustomEvent<BrowserRuntimeTraceEvent>(SECUREBLOB_RUNTIME_TRACE_EVENT, {
        detail,
    }))
}
